import { usePostHog } from 'posthog-js/react';
import React, { useEffect } from 'react';

import { getClientFlagsContextValue } from 'src/context';

/**
 * Subscribes to PostHog feature flag updates and syncs them to React state.
 * Must be rendered inside PostHogProvider.
 */
export const FeatureFlagSync: React.FC<{
  onFlagsChange: (flags: ReturnType<typeof getClientFlagsContextValue>) => void;
}> = ({ onFlagsChange }) => {
  const posthog = usePostHog();

  useEffect(() => {
    if (!posthog) return;

    const onFeatureFlagChange = posthog.onFeatureFlags(() => {
      const clientFlags = getClientFlagsContextValue(posthog);
      onFlagsChange(clientFlags);
    });

    return onFeatureFlagChange;
  }, [posthog, onFlagsChange]);

  return null;
};
